import { AllAdminProjectsPage } from '../pages/AllAdminProjects.page';
import { AdminPendingProjectsPage } from '../pages/AdminPendingProjects.page';
import { AdminScheduledProjectsPage } from '../pages/AdminScheduledProjects.page';
import { AdminLiveProjectsPage } from '../pages/AdminLiveProjects.page';
import { AdminCompletedProjectsPage } from '../pages/AdminCompletedProjects.page';

export const AllProjectTabsWrapper = () => {
  return (
    <>
      <AllAdminProjectsPage />
      <AdminPendingProjectsPage />
      <AdminScheduledProjectsPage />
      <AdminLiveProjectsPage />
      <AdminCompletedProjectsPage />
    </>
  );
};
